var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThird(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 51,
    viewBox: "0 0 50 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_516_1056)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 50,
    height: 50,
    rx: 12,
    fill: "#AAE7AC"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_516_1056)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.89648 51.6769H20.315C21.321 48.0049 21.824 45.3389 21.9247 44.3831C21.9247 44.3831 22.1762 38.9505 16.5927 39.4535C16.5927 39.4535 10.2546 39.3529 9.1983 46.697C9.2486 46.697 9.2989 48.5079 8.89648 51.6769Z",
    fill: "#FB7C2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.7652 29.9971H22.5781V38.2969H28.7652V29.9971Z",
    fill: "#F8B78F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.7305 41.8687C38.0203 39.2027 35.304 38.4985 35.304 38.4985L28.815 36.084H22.5776L16.0887 38.4985C16.0887 38.4985 13.3724 39.2027 11.6621 41.8687H39.7305Z",
    fill: "#F8B78F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.1721 51.677V51.023L41.0393 45.3389C40.1842 39.8057 35.3552 38.4979 35.3552 38.4979L30.3754 36.6367L24.7416 38.5482L20.9186 36.687L16.0896 38.4979C16.0896 38.4979 11.2104 39.8057 10.3552 45.3389L12.6691 51.7273H38.1721V51.677Z",
    fill: "#FB7C2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4317 51.6769H43.7556C42.146 46.4455 40.5866 42.8238 39.983 41.7171C39.983 41.7171 37.0655 37.1397 32.7898 40.7614C32.7898 40.7614 27.5584 44.3328 30.9287 50.9727C30.9287 50.9727 31.0796 51.2242 31.4317 51.6769Z",
    fill: "#FB7C2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2842 18.1766C15.1333 17.07 15.0327 16.6676 14.9824 14.0016C14.9824 12.744 15.2339 10.8326 16.7933 10.6817C18.9563 10.4805 19.6605 14.2028 19.7611 15.8628C19.9623 18.1263 19.3587 20.5408 18.9563 22.7038C18.8054 23.5086 18.8054 25.068 17.8999 25.4704C17.1454 25.8225 17.246 25.9231 16.8939 25.3698C15.9382 23.9613 15.4854 19.7863 15.2842 18.1766Z",
    fill: "#472D11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4409 28.8398C17.296 32.21 18.8051 33.1155 18.8051 33.1155L20.8172 33.5179C21.9741 33.367 23.9862 32.9142 23.9862 32.9142C28.614 31.3549 30.1733 31.4555 31.129 29.041C31.1793 28.9907 34.3484 16.5159 34.3484 16.5159C35.0023 9.97662 28.2115 8.61848 27.2055 8.46757C26.1995 8.21606 19.7105 6.4555 17.7991 12.6426C17.7991 12.6426 14.9822 19.8861 16.4409 28.8398Z",
    fill: "#F8B78F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.6703 30.0977C27.8091 31.5565 24.6401 32.5122 22.3262 32.7134C18.2015 33.1661 17.296 30.148 16.5918 26.9287C16.6421 27.6832 16.7427 28.4378 16.8433 29.1923C17.6481 32.311 19.0566 33.2164 19.0566 33.2164L20.9681 33.5686C22.0747 33.4176 23.9359 32.9649 23.9359 32.9649C28.2618 31.5062 29.7206 31.5565 30.5757 29.3432C30.5757 29.3432 30.626 29.0917 30.7266 28.7396C30.4751 29.2426 30.123 29.7456 29.6703 30.0977Z",
    fill: "#E6AB86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6964 6.30471C27.6079 6.0532 29.8715 5.55018 31.783 6.20411C34.2981 7.05924 34.2981 9.92644 35.455 11.8882C36.6622 14.0009 37.4671 15.7614 37.3665 18.0753C37.2659 19.8359 36.6119 18.9808 36.3604 20.7916C36.0586 22.8037 35.7065 22.9546 34.7508 24.6649L31.1793 28.9908C31.7327 26.7775 31.3302 26.3751 31.8333 24.6649C32.4369 22.6025 32.286 19.8862 31.3805 17.8238C30.5757 15.9627 30.0224 16.013 28.3121 15.5602C26.0989 15.0069 24.2377 14.7554 21.9238 14.7554C19.8614 14.7051 17.5476 14.6548 15.8876 13.2464C14.3282 11.9385 13.7749 9.12161 14.3282 7.15984C14.3282 7.15984 15.284 4.99686 17.95 5.60048C19.6099 5.9526 21.2699 6.45562 22.9801 6.50592C23.8856 6.50592 24.791 6.45562 25.6964 6.30471Z",
    fill: "#472D11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3805 23.4579C31.3805 23.4579 32.5374 20.9429 34.3483 22.4519C34.3483 22.4519 35.1531 23.1058 34.1471 24.7658C34.1471 24.7658 32.6883 27.1803 30.9277 25.8221L31.3805 23.4579Z",
    fill: "#F8B78F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5817 17.623C31.5817 17.623 31.5817 22.0999 30.7266 24.4641L31.5817 24.615C31.5817 24.615 32.0344 21.5466 33.6441 21.4963L31.5817 17.623Z",
    fill: "#472D11"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_516_1056"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 50,
    height: 50,
    rx: 12,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_516_1056"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46.6298,
    height: 50,
    fill: "white",
    transform: "translate(1 5.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThird);
export default __webpack_public_path__ + "static/media/third.2b34403897d42846a0b5aa6d4d7550bf.svg";
export { ForwardRef as ReactComponent };